export interface State {
  packageGuid: string | null;
  isAudioVideoCheckComplete: boolean;
  isRequiredForPackage: boolean;
  audioVideoDevices: MediaDeviceInfo[];
  mediaStream: MediaStream | null;
  error: string | null;
}

export const initialState: State = {
  packageGuid: null,
  isAudioVideoCheckComplete: false,
  isRequiredForPackage: false,
  audioVideoDevices: [],
  mediaStream: null,
  error: null,
};
